import { Action as ReduxAction } from 'redux'
import { ConsentBannerAction } from '../constants'

/* Action definitions */
export interface IHideConsentBanner extends ReduxAction {
  // tslint:disable-next-line:no-reserved-keywords
  type: ConsentBannerAction.HIDE_CONSENT_BANNER
}

/* Action creators */
export const hideConsentBanner = (): IHideConsentBanner => ({
  type: ConsentBannerAction.HIDE_CONSENT_BANNER,
})

export type HideConsentBannerAction = IHideConsentBanner
